import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    padding: theme.spacing(4, 4, 0, 4),
    whiteSpace: 'nowrap',
  },
  resizeFontTextField: {
    width: 255,
    '& .MuiInputBase-input': {
      fontSize: '14px',
    },
    '& .MuiInputLabel-formControl': {
      fontSize: '14px',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
  },
  defaultValueWidth: {
    width: '220px',
  },
  selectField: {
    width: '211px',
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  menuRoot: {
    '&.MuiMenuItem-root': {
      fontSize: '13px',
      color: theme.palette.headerTitle.main,
    },
    '&.MuiListItem-gutters': {
      padding: theme.spacing(1.5),
    },
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
    '&.MuiListItem-button:hover': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '200px',
  },
  submitButton: {
    marginRight: theme.spacing(3),
  },
  actionIcon: {
    color: theme.palette.icon.main,
    height: '24px',
    width: '24px',
    cursor: 'pointer',
    marginRight: theme.spacing(3),
    '&.css-ptiqhd-MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
    },
  },
  actionIconDisabled: {
    opacity: 0.3,
  },
  contractLink: {
    textDecoration: 'none',
    color: theme.palette.icon.main,
  },
}))
